module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-crm/04-e44e609eecad4c3bccd45fe630c06bc6.png";